"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticationReducer = void 0;

var tslib_1 = require("tslib");

var constants_1 = require("../lib/constants");

var authenticationActions_1 = require("./authenticationActions");

var authenticationReducer = function authenticationReducer(state, action) {
  switch (action.type) {
    case authenticationActions_1.AUTHENTICATION_ACTIONS.AUTHENTICATION_TOKEN_LOAD:
      return tslib_1.__assign(tslib_1.__assign({}, state), {
        authenticationStatus: constants_1.FETCH_STATUSES.LOADING
      });

    case authenticationActions_1.AUTHENTICATION_ACTIONS.AUTHENTICATION_TOKEN_ERROR:
      return tslib_1.__assign(tslib_1.__assign({}, state), {
        authenticationStatus: constants_1.FETCH_STATUSES.ERROR,
        error: action.payload
      });

    case authenticationActions_1.AUTHENTICATION_ACTIONS.AUTHENTICATION_TOKEN_SET:
      return tslib_1.__assign(tslib_1.__assign({}, state), {
        authenticationToken: action.payload.token,
        authenticationStatus: constants_1.FETCH_STATUSES.SUCCESS
      });

    case authenticationActions_1.AUTHENTICATION_ACTIONS.LOGIN_URL_SET:
      return tslib_1.__assign(tslib_1.__assign({}, state), {
        loginUrl: action.payload.loginUrl
      });

    default:
      return tslib_1.__assign({}, state);
  }
};

exports.authenticationReducer = authenticationReducer;